const washAndIronMan = [
	{
        id: '1101',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Topwear (Shirt / T-shirt / Fatua)',
		category: "Men's Wear",
		service: 'Wash And Iron',
		price: 40,
		quantity: 1
	},
	{
		id: '1102',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Bottom Wear (Trouser / Jeans / Pajama)',
		category: "Men's Wear",
		service: 'Wash And Iron',
		price: 45,
		quantity: 1
	},
	{
		id: '1103',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Winter Wear (Sweater / Hoodies)',
		category: "Men's Wear",
		service: 'Wash And Iron',
		price: 85,
		quantity: 1
	},
	{
		id: '1104',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Home Wear (Sleeping suit / Nightdress)',
		category: "Men's Wear",
		service: 'Wash And Iron',
		price: 55,
		quantity: 1
	},
	{
		id: '1105',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Premium (Blazer / Coat / Jacket)',
		category: "Men's Wear",
		service: 'Wash And Iron',
		price: 140,
		quantity: 1
	},
	{
		id: '1107',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Jubba / Kabuli suit',
		category: "Men's Wear",
		service: 'Wash And Iron',
		price: 55,
		quantity: 1
	},
	{
		id: '1108',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Inner Wear (Socks / Shorts / Under Garments)',
		category: "Men's Wear",
		service: 'Wash And Iron',
		price: 25,
		quantity: 1
	},
	{
		id: '1109',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Exclusive Panjabi',
		category: "Men's Wear",
		service: 'Wash And Iron',
		price: 100,
		quantity: 1
	},
	{
		id: '1110',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Suit (Blazer + Trouser)',
		category: "Men's Wear",
		service: 'Wash And Iron',
		price: 180,
		quantity: 1
	},
	{
		id: '1111',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Suit (Blazer + Trouser + Waist Coat)',
		category: "Men's Wear",
		service: 'Wash And Iron',
		price: 220,
		quantity: 1
	},
	{
		id: '1112',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Sherwani',
		category: "Men's Wear",
		service: 'Wash And Iron',
		price: 300,
		quantity: 1
	},
	{
		id: '1113',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Shawl',
		category: "Men's Wear",
		service: 'Wash And Iron',
		price: 70,
		quantity: 1
	}
];
export default washAndIronMan;
